import React, { useState } from 'react'
import Paginations from '../../common/paginations';
import moment from 'moment';
import constant from '../../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { v3_upload_plan_approval_document } from '../../../actions/v3/planApproval';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { uploadSelectedFiles } from '../../../utils/multipleFileUpload';

const Index = ({ records, handlePageChange, limit, onChangeFavouriteStatus, onUpdateStatus, onAddRevision }) => {


    const location = useLocation();
    const { projectName } = location.state;
    const { data, page, total } = records;

    const [state, setState] = useState({
        revisionName: { name: 'revisionName', value: '', error: '', isRequired: true },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },
        document: { name: 'document', value: [{ fileName: '', originalFileName: '' }], error: '', isRequired: false }
    })


    const [statusState, setStatusState] = useState({
        status: {
            name: 'status', value: '', error: '', options: ['Draft', 'Approved', 'Approved With Comments', 'Not Accepted', 'Reference'], isRequired: true
        },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },
    })

    const [planId, setPlanId] = useState('')



    const addFileField = () => {
        setState(prev => ({
            ...prev,
            document: {
                ...prev.document,
                value: [...prev.document.value, { fileName: '', originalFileName: '' }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.document.value.filter((_, i) => i !== index);
        setState(prev => ({
            ...prev,
            document: {
                ...prev.document,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };

    const handleFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setState(prev => {
            const updatedFiles = [...prev.document.value];
            updatedFiles.splice(index, 1, ...uploadedFiles);
            return {
                ...prev,
                document: { ...prev.document, value: updatedFiles, error: '' }
            };
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };

    const handleStatusStateChange = (e) => {
        const { name, value } = e.target;
        setStatusState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };

    const handleSubmit = () => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            remarks: state.remarks.value,
            documentFiles: state.document.value,
            revisionName: state.revisionName.value,
            planId: planId
        };

        onAddRevision(payload)
    };

    const handleStatusUpdateSubmit = () => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...statusState };

        Object.keys(statusState).forEach((key) => {
            if (statusState[key].isRequired && !statusState[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setStatusState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            remarks: statusState.remarks.value,
            status: statusState.status.value,
            planId: planId
        };

        onUpdateStatus(payload)
    };

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table className="plan-approval-table">
                        <thead>
                            <tr>
                                <th className="w70">DFA No.</th>
                                <th className="w80">Channel</th>
                                <th className="w80">Type</th>
                                <th className="w100">Category</th>
                                <th className="w250">Plan Name/Plan Number</th>
                                <th className="w150">Revisions</th>
                                <th className="w150">Assigned Users</th>
                                <th className="w200">Comments</th>
                                <th className="w100">Date Created</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? data.map((item) => {
                                return (
                                    <tr>
                                        <td>
                                            <Link
                                                to={{
                                                    pathname: constant.Authedcomponent.planApprovalDetail.url,
                                                    state: {
                                                        page,
                                                        planName: item.PLAN_NAME,
                                                        projectId: item.PROJECT_ID,
                                                        planId: item.ID,
                                                        projectName: projectName,

                                                    }
                                                }}
                                            >
                                                <p className="s1">
                                                    <a href="">{item.ID}</a>
                                                </p>
                                                {/* <p className="s1">AA</p> */}
                                            </Link>
                                            <p>
                                                {item.STATUS}
                                            </p>
                                        </td>
                                        <td>
                                            <Link
                                                to={{
                                                    pathname: constant.Authedcomponent.planApprovalDetail.url,
                                                    state: {
                                                        page,
                                                        planName: item.PLAN_NAME,

                                                        projectId: item.PROJECT_ID,
                                                        planId: item.ID,
                                                        projectName: projectName,


                                                    }
                                                }}
                                            >
                                                <p className="s1">{item.CHANNEL_NAME}</p>
                                            </Link>

                                        </td>
                                        <td>
                                            <Link
                                                to={{
                                                    pathname: constant.Authedcomponent.planApprovalDetail.url,
                                                    state: {
                                                        page,
                                                        planName: item.PLAN_NAME,

                                                        projectId: item.PROJECT_ID,
                                                        planId: item.ID,
                                                        projectName,

                                                    }
                                                }}
                                            >
                                                <p className="s1">{item.PLAN_TYPE}</p>
                                            </Link>

                                        </td>
                                        <td>
                                            <Link
                                                to={{
                                                    pathname: constant.Authedcomponent.planApprovalDetail.url,
                                                    state: {
                                                        page,
                                                        planName: item.PLAN_NAME,

                                                        projectId: item.PROJECT_ID,
                                                        planId: item.ID,
                                                        projectName,


                                                    }
                                                }}
                                            >
                                                <p className="s1">{item.CATEGORY_NAME}</p>
                                            </Link>

                                        </td>
                                        <td>
                                            <Link
                                                to={{
                                                    pathname: constant.Authedcomponent.planApprovalDetail.url,
                                                    state: {
                                                        page,
                                                        planName: item.PLAN_NAME,

                                                        projectId: item.PROJECT_ID,
                                                        planId: item.ID,
                                                        projectName,

                                                    },
                                                }}
                                            >
                                                <p className="s1 mb-1">
                                                    {item.PLAN_NAME} ({item.PLAN_NUMBER})
                                                </p>
                                            </Link>

                                            <div className="d-flex align-items-center gap-2 ms-2">
                                                <i
                                                    className={`bx ${Number(item.IS_FAVOURITE) ? 'bxs-star' : 'bx-star'}`}
                                                    style={{
                                                        color: Number(item.IS_FAVOURITE) ? '#f1c40f' : '#999',
                                                        cursor: 'pointer',
                                                        fontSize: '18px',
                                                    }}
                                                    onClick={() => {
                                                        onChangeFavouriteStatus({
                                                            planId: item.ID,
                                                            favouriteStatus: Number(!Number(item.IS_FAVOURITE)),
                                                        });
                                                    }}
                                                />
                                                <i
                                                    className="bx bx-edit"
                                                    style={{ cursor: 'pointer', fontSize: '18px' }}
                                                    onClick={() => {
                                                        setPlanId(item.ID)
                                                    }}
                                                    data-bs-toggle="modal"
                                                    data-bs-target={`#statusUpdateModal`}
                                                />
                                            </div>

                                            <div
                                                className="modal fade"
                                                id={`statusUpdateModal`}
                                                data-bs-backdrop="static"
                                                data-bs-keyboard="false"
                                                tabIndex={-1}
                                                role="dialog"
                                                aria-labelledby="statusUpdateModalLabel"
                                                aria-hidden="true"
                                            >
                                                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title" id="statusUpdateModalLabel">
                                                                Update Status
                                                            </h5>
                                                            <button
                                                                type="button"
                                                                className="btn-close"
                                                                data-bs-dismiss="modal"
                                                                aria-label="Close"
                                                            />
                                                        </div>
                                                        <div className="modal-body">
                                                            <div className="row">
                                                                <div className="col-md-12 mb-3">
                                                                    <label>Status <span >*</span></label>
                                                                    <select
                                                                        name={'status'}
                                                                        value={statusState['status'].value}
                                                                        onChange={handleStatusStateChange}
                                                                        className={`form-control ${statusState['status'].error ? 'is-invalid' : ''}`}
                                                                    >
                                                                        <option value=''>Select Status</option>
                                                                        {statusState.status.options.map((status) => {
                                                                            return (
                                                                                <option value={status}>{status}</option>

                                                                            )
                                                                        })}
                                                                    </select>
                                                                    {statusState['status'].error && <div className="invalid-feedback">{statusState['status'].error}</div>}
                                                                </div>

                                                                <div className="col-md-12 mb-3">
                                                                    <label>Remarks</label>
                                                                    <textarea
                                                                        row='2'
                                                                        name={'remarks'}
                                                                        placeholder='Enter Remarks'
                                                                        value={statusState['remarks'].value}
                                                                        onChange={handleStatusStateChange}
                                                                        className={`form-control ${statusState['remarks'].error ? 'is-invalid' : ''}`}
                                                                    />
                                                                    {statusState['remarks'].error && <div className="invalid-feedback">{statusState['remarks'].error}</div>}
                                                                </div>
                                                            </div>
                                                            <div className="mt-3">
                                                                <button type="submit" className="btn btn-success me-2"
                                                                    onClick={() => {
                                                                        handleStatusUpdateSubmit()

                                                                    }}
                                                                >Submit</button>
                                                                <button className="btn btn-danger text-white" onClick={() => {
                                                                    const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal`));
                                                                    if (modal) modal.hide();
                                                                }}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="revisions-td">
                                            {item.revisions.map((rev) => {
                                                return (
                                                    <div className="s1-box">
                                                        <p className="s1 s1-info">
                                                            <i className="fa fa-file" /> Rev. {rev.REVISION_NAME}
                                                        </p>
                                                        <p className="s1">{moment(rev.CREATED_ON).format('MMM DD YYYY')}</p>
                                                    </div>
                                                )
                                            })}

                                            {/* Create New Revision button (initially hidden) */}
                                            <div className="s1-box">
                                                <button
                                                    className="btn btn-sm btn-primary me-2 create-rev-btn"
                                                    onClick={() => {
                                                        setPlanId(item.ID)
                                                    }}
                                                    style={{
                                                        backgroundImage:
                                                            "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                                                    }}
                                                    data-bs-toggle="modal"
                                                    data-bs-target={`#revisionModal`}
                                                >
                                                    + New Revision
                                                </button>
                                            </div>
                                            <div
                                                className="modal fade"
                                                id={`revisionModal`}
                                                data-bs-backdrop="static"
                                                data-bs-keyboard="false"
                                                tabIndex={-1}
                                                role="dialog"
                                                aria-labelledby="revisionModalLabel"
                                                aria-hidden="true"
                                            >
                                                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title" id="revisionModalLabel">
                                                                Add Revision
                                                            </h5>
                                                            <button
                                                                type="button"
                                                                className="btn-close"
                                                                data-bs-dismiss="modal"
                                                                aria-label="Close"
                                                            />
                                                        </div>
                                                        <div className="modal-body">
                                                            <div className="row">
                                                                <div className="col-md-12 mb-3">
                                                                    <label>Revision Name <span >*</span></label>
                                                                    <input
                                                                        type='text'
                                                                        name={'revisionName'}
                                                                        placeholder='Enter Revision Name'
                                                                        value={state['revisionName'].value}
                                                                        onChange={handleChange}
                                                                        className={`form-control ${state['revisionName'].error ? 'is-invalid' : ''}`}
                                                                    />
                                                                    {state['revisionName'].error && <div className="invalid-feedback">{state['revisionName'].error}</div>}
                                                                </div>

                                                                <div className="col-md-12 mb-3">
                                                                    <label>Remarks <span >*</span></label>
                                                                    <textarea
                                                                        row='2'
                                                                        name={'remarks'}
                                                                        placeholder='Enter Remarks'
                                                                        value={state['remarks'].value}
                                                                        onChange={handleChange}
                                                                        className={`form-control ${state['remarks'].error ? 'is-invalid' : ''}`}
                                                                    />
                                                                    {state['remarks'].error && <div className="invalid-feedback">{state['remarks'].error}</div>}
                                                                </div>
                                                                {state.document.value.map((item, index) => (
                                                                    <div key={index} className="d-flex align-items-center mb-2">
                                                                        {item.fileName ? (
                                                                            <>
                                                                                <div className="me-2 flex-grow-1">
                                                                                    <span>{item.originalFileName}</span>
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-danger"
                                                                                    onClick={() => removeFileField(index)}
                                                                                >
                                                                                    <FaTrash />
                                                                                </button>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <input
                                                                                    type="file"
                                                                                    multiple
                                                                                    onChange={(e) => handleFileChange(index, e.target.files)}
                                                                                    className="form-control me-2"
                                                                                />
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-danger"
                                                                                    onClick={() => removeFileField(index)}
                                                                                >
                                                                                    <FaTrash />
                                                                                </button>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                ))}

                                                                {/* Add button always visible below the list */}
                                                                <div>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-primary"
                                                                        onClick={addFileField}
                                                                    >
                                                                        <FaPlus className="me-1" /> Add Document
                                                                    </button>
                                                                </div>

                                                                {state.document.error && (
                                                                    <div className="text-danger mt-1">{state.document.error}</div>
                                                                )}
                                                            </div>
                                                            <div className="mt-3">
                                                                <button type="submit" className="btn btn-success me-2"
                                                                    onClick={() => {
                                                                        handleSubmit()

                                                                    }}
                                                                >Submit</button>
                                                                <button className="btn btn-danger text-white" onClick={() => {
                                                                    const modal = window.bootstrap.Modal.getInstance(document.getElementById(`revisionModal`));
                                                                    if (modal) modal.hide();
                                                                }}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="s1-box">
                                                <p className="s1">Rev.C (H1563-68)</p>
                                                <p className="s1">Oct 16 2023</p>
                                            </div> */}
                                        </td>
                                        <td className="assigned-users">
                                            <div className="assigned-dib">
                                                {/* <p className="s1">
                                                    <span>OJ</span> OCtavian Jipa
                                                </p> */}
                                                <ul className="assigned-list">
                                                    {item.assignee.map((user, userIndx) => {
                                                        const initials = user.FULL_NAME
                                                            .split(' ')
                                                            .map(word => word.charAt(0).toUpperCase())
                                                            .join('');

                                                        return (
                                                            <li key={userIndx}>
                                                                <span>{initials}</span>
                                                            </li>
                                                        );
                                                    })}

                                                </ul>
                                            </div>
                                            {/* <div className="assigned-dib">
                                                <p className="s1">
                                                    <span>OJ</span> OCtavian Jipa
                                                </p>
                                                <ul className="assigned-list">
                                                    <li>
                                                        <span>IP</span>
                                                    </li>
                                                    <li>
                                                        <span>df</span>
                                                    </li>
                                                    <li>
                                                        <span>cf</span>
                                                    </li>
                                                    <li>
                                                        <span>hr</span>
                                                    </li>
                                                    <li>
                                                        <span>me</span>
                                                    </li>
                                                    <li>
                                                        <span>ht</span>
                                                    </li>
                                                    <li>
                                                        <span>cf</span>
                                                    </li>
                                                    <li>
                                                        <span>hr</span>
                                                    </li>
                                                    <li>
                                                        <span>me</span>
                                                    </li>
                                                    <li>
                                                        <span>ht</span>
                                                    </li>
                                                </ul>
                                            </div> */}
                                        </td>
                                        <td className="comments-td-box">
                                            <p className="s1 s1-info">
                                                <i className="bx bxs-message" /> {item.totalComments}
                                            </p>
                                            <ul className="comments-listbox">
                                                {Object.entries(item.commentCountByStatus).map(([status, count], idx) => (
                                                    <li key={idx}>
                                                        <span>{count}</span> {status === 'Approved Subjected to Comments' ? 'Approved With Comments' : status}
                                                    </li>
                                                ))}
                                            </ul>
                                        </td>
                                        <td>
                                            <p className="s1">{moment(item.CREATED_ON).format('MMM DD, YYYY')}</p>
                                        </td>
                                    </tr>
                                )
                            }) : ''}


                        </tbody>
                    </table>
                    <Paginations

                        limit={limit}
                        totalCount={total}
                        range={5}
                        currentPage={page}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>
        </div >
    )
}

export default Index
